import type { NuxtRouteParamValue, NuxtLocationQuery } from '@@/shared/application';

export type NormalizedParam = Array<string>;

export function normalizeUrlParam(param?: NuxtRouteParamValue): NormalizedParam {
  if (typeof param === `undefined`) return [];
  if (Array.isArray(param)) return param;
  return [param];
}

export function normalizeStringSearchParam(value: NuxtLocationQuery | NuxtRouteParamValue): string | undefined {
  if (Array.isArray(value)) value = value[0];
  if (typeof value === `string`) return value.trim();
  return undefined;
}

export function normalizeNumberSearchParam(value: NuxtLocationQuery | NuxtRouteParamValue): number | undefined {
  if (Array.isArray(value)) value = value[0];
  if (typeof value !== `string`) return undefined;
  const parsedValue = Number.parseInt(value);
  if (Number.isNaN(parsedValue)) return undefined;
  return parsedValue;
}

export function normalizeArraySearchParam(value?: NuxtLocationQuery | NuxtRouteParamValue): NormalizedParam {
  const valueAsArray = (Array.isArray(value) ? value : [value]).filter(value => typeof value === `string`);
  return [...new Set(valueAsArray)];
}

export interface HeadHrefLangLink {
  id: string
  rel: string
  href: string
  hreflang?: string
};
